var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tipp-up-down-arrow"},[_c('img',{staticClass:"arrow",class:{rotate: _vm.rotate},attrs:{"src":require("../assets/tipp/tipp-up.svg")},on:{"click":function($event){return _vm.$emit('toggled')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }